// extracted by mini-css-extract-plugin
export const hello = "Homepage-module--hello--16w6L";
export const pre = "Homepage-module--pre--3SAiQ";
export const title = "Homepage-module--title--SxT8X";
export const subtitle = "Homepage-module--subtitle--1-BVM";
export const description = "Homepage-module--description--x3AhO";
export const fallbackHello = "Homepage-module--fallbackHello--1ZGm4";
export const comments = "Homepage-module--comments--1bVyr";